import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "delete-outline--sprite",
  "use": "delete-outline--sprite-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 32 32\" id=\"delete-outline--sprite\">\n\t<defs>\n\t\t<path id=\"delete-outline--sprite_a\" d=\"M17 .425L16.49 0 8.5 7.99.425 0 0 .425 7.99 8.5 0 16.49l.425.51L8.5 8.925 16.49 17l.51-.51L8.925 8.5z\" />\n\t</defs>\n\t<use fill=\"#565D60\" fill-rule=\"evenodd\" stroke=\"#565D60\" stroke-width=\".4\" transform=\"translate(7 8)\" xlink:href=\"#delete-outline--sprite_a\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol